<template>
  <div @mouseenter="mouseenter" @mouseleave="mouseleave">
    <slot></slot>
  </div>
</template>
<script>
import Swiper from "swiper/bundle";

export default {
  data() {
    return {
      swiper: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$el, {
        slidesPerView: "auto",
        hashNavigation: false,
        spaceBetween: 0,
        speed: 500,
        loop: true,
        autoplay: {
          delay: 500,
          disableOnInteraction: false
        },
        navigation: false,
        allowTouchMove: false,
        //allowSlidePrev: false,
        //allowSlideNext: false,
      });
      this.swiper.autoplay.stop();
    });
  },
  methods: {
    mouseenter() {
      if (this.swiper) {
        this.swiper.autoplay.start();
      }
    },
    mouseleave() {
      if (this.swiper) {
        this.swiper.autoplay.stop();
      }
    }
  }
};
</script>
